import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountdownModule } from 'ngx-countdown';

import { CountdownSharedComponent } from './countdown.component';

@NgModule({
    declarations: [
        CountdownSharedComponent
    ],
    imports: [
        CommonModule,
        CountdownModule
    ],
    exports: [
        CountdownSharedComponent
    ]
})

export class CountdownSharedModule {}
